import { EventEmitter, inject, Injectable, signal, WritableSignal } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  OpenQuoteRequestResponse,
  QuoteRequestsListItem,
  QuoteRequestsListResponse,
} from '@sbd-doug-frontend/shared/lib/types/quote-request/quote-request.types';
import { AbstractQuoteRequestsListService } from '@sbd-doug-frontend/shared/lib/shared-services/quote-requests-list.abstract.service';
import { ENVIRONMENT_INJECTION_TOKEN } from '@sbd-doug-frontend/shared/lib/injections/environment-injection-token';

@Injectable({ providedIn: 'root' })
export class DougQuoteRequestsListService extends AbstractQuoteRequestsListService {
  private _environment = inject(ENVIRONMENT_INJECTION_TOKEN);

  override totalQuoteRequests: WritableSignal<number> = signal<number>(0);
  override quoteRequests: WritableSignal<QuoteRequestsListItem[]> = signal<QuoteRequestsListItem[]>([]);
  override notFilterableFields: WritableSignal<string[]> = signal<string[]>([]);
  override triggerRefresh = new EventEmitter<void>();
  override isLoading: WritableSignal<boolean> = signal<boolean>(false);

  override getQuoteRequestsList(filters: any = {}): Observable<QuoteRequestsListItem[]> {
    const params = filters || {};
    this.isLoading.set(true);
    return this._httpClient
      .get<QuoteRequestsListResponse>(
        `${this._environment.apiBaseUrl}/v4/quote/requests`,
        { params },
      ).pipe(
        map((response) => {
          this.quoteRequests.set(response.data.quote_requests.quote_requests);
          this.totalQuoteRequests.set(response.data.quote_requests.total_quote_requests);
          this.notFilterableFields.set(response.data.not_filterable);
          this.isLoading.set(false);
          return response.data.quote_requests.quote_requests;
        }),
      );
  }

  override loadQuoteRequest(quoteRequestId: number, accountId: number = null): Observable<QuoteRequestsListItem> {
    const url = accountId ? `${this._environment.apiBaseUrl}/v4/quote/account/${accountId}/load-request/${quoteRequestId}` :
      `${this._environment.apiBaseUrl}/v4/quote/load-request/${quoteRequestId}`;

    return this._httpClient
      .get<OpenQuoteRequestResponse>(
        url,
      ).pipe(
        map((response) => {
          if (!response.success) {
            this._cathyService.error(response.message);
          }
          return response.data.quote_request.quote_request;
        }),
      );
  }
}
